import { PropsWithChildren } from "react";

import { useRecentJiraSite } from "@/templates/software/jira/logged-in/utils/use-recent-jira-site";

import { JiraSiteSkeleton } from "./jira-site-skeleton";

export const JiraSiteContainer = ({
    children,
    isTreatment
}: PropsWithChildren<{ isTreatment: boolean }>) => {
    const { siteName, siteInitials, siteUrl } = useRecentJiraSite();

    if (isTreatment) {
        if (siteName === "" || siteInitials === "" || siteUrl === "") {
            return <JiraSiteSkeleton />;
        }
    }

    return children;
};
